/**
 * @file index.tsx
 *
 * @fileoverview Displays the form that handles searching for fulltext and region autocomplete.
 */
import React from 'react';
import SearchInputForm from '~/jobiqo/components/Search/SearchInputForm';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface OrganizationSearchInputFormProps {
  /**
   * The current querystring object.
   */
  querystring?: any;
}

export const OrganizationSearchInputForm = ({
  querystring,
}: OrganizationSearchInputFormProps) => {
  const { ORGANIZATIONS } = useFrontendConfig();
  return (
    <SearchInputForm
      querystring={querystring}
      endpoint="organizations"
      searchUrl={ORGANIZATIONS.ORGANIZATIONS_SEARCH_PAGE}
      geoInfo={ORGANIZATIONS.GEO_INFO}
      hideGeoSearch={ORGANIZATIONS.HIDE_GEO_SEARCH}
      hideKeywordSearch={ORGANIZATIONS.HIDE_KEYWORD_SEARCH}
    />
  );
};
export default OrganizationSearchInputForm;
